import { useLocalStorageValue } from '@react-hookz/web';

import { KEYS } from '@lib/services/storageService';

function sanitizeToken(token?: string | null | Record<string, string>) {
  let result = token;
  if (typeof result === 'object') {
    return result?.token ?? '';
  }

  try {
    const parsedToken = JSON.parse(result ?? '');
    // web-app is storing the token as object
    if (typeof parsedToken === 'object' && parsedToken?.token) {
      result = parsedToken.token;
    } else {
      // ui-next is storing token as string
      result = result && result.replace(/"/g, '');
    }
  } catch (err) {
    result = result && typeof result === 'string' ? result.replace(/"/g, '') : '';
  }
  return String(result);
}

export default function useCurrentToken(): [string | null, (token: string | null) => void] {
  const [token, setToken] = useLocalStorageValue<string | Record<string, string>>(KEYS.user);
  return [sanitizeToken(token) || null, setToken as any];
}
